import { DealFilingSection } from "@/types/deals.types";
import { useScroll } from "@FillInTableContainer/components/FillInTable/hooks/useScroll";
import useArticleSection from "@FillInTableContainer/hooks/useArticleSection";
import { TableCreatorGroupTableTitle } from "@FillInTableContainer/shared";
import { useCanEditGroupTable } from "@FillInTableContainer/shared/hooks/useCanEditGroupTable";
import { TableCreatorSubGroupShellTableList } from "@FillInTableContainer/shared/types/tableCreator.types";
import { isRequiredGroupTable } from "@FillInTableContainer/shared/utils/getOptionsFromData";
import { getGroupTableTitle } from "@FillInTableContainer/shared/utils/getTextFromData";

import DealTermsVentureFormationTable from "./components/DealTermsVentureFormationTable/DealTermsVentureFormationTable";
import * as S from "./DealTermsMergeGroupTable.style";

interface Props {
  groupTableKey: DealFilingSection;
  tableList: TableCreatorSubGroupShellTableList;
  groupTableIndex: number;
}

const DealTermsVentureFormationGroupTable = ({
  groupTableIndex,
  groupTableKey,
  tableList,
}: Props) => {
  const { register } = useScroll();
  const articleSection = useArticleSection();

  const { checkDisableEdit } = useCanEditGroupTable();

  return (
    <S.GroupTableWrapper
      isDisableEdit={checkDisableEdit(groupTableKey)}
      {...register(groupTableKey)}
    >
      <TableCreatorGroupTableTitle
        title={getGroupTableTitle(articleSection, groupTableKey)}
        isRequired={isRequiredGroupTable(articleSection, groupTableKey)}
      />
      <S.TableCreatorTableListWrapper
        isDisableEdit={checkDisableEdit(groupTableKey)}
      >
        {tableList.map(({ tableKey, groupShellList }, tableIndex) => {
          return (
            <DealTermsVentureFormationTable
              key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}
              tableKey={tableKey}
              groupShellList={groupShellList}
              groupTableKey={groupTableKey}
              groupTableIndex={groupTableIndex}
              tableIndex={0}
            />
          );
        })}
      </S.TableCreatorTableListWrapper>
    </S.GroupTableWrapper>
  );
};

export default DealTermsVentureFormationGroupTable;
